<template>
  <div id="login">
    <vue-headful :title="$store.state.option['login_title-' + lang]" :lang="lang" />
    <titulo></titulo>

    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-md-12 col-xs-12">
          <h2 class="text-center mt-5">{{$store.state.option['login_cliente-' + lang]}}</h2>
          <div class="card card-login mx-auto">
            <div class="card-body">
              <form @submit.prevent="submitClient()">
                <div class="form-group">
                  <div class="form-label-group">
                    <input type="text" id="inputClientId" class="form-control" :placeholder="$store.state.option['clientID-' + lang]" required="required" v-model="client.clientID" />
                    <label for="inputClientId">{{$store.state.option['clientID-' + lang]}}</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input type="text" id="inputUsername" class="form-control" :placeholder="$store.state.option['username-' + lang]" required="required" v-model="client.username" />
                    <label for="inputUsername">{{$store.state.option['username-' + lang]}}</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input type="password" id="inputPassword1" class="form-control" :placeholder="$store.state.option['senha-' + lang]" required="required" v-model="client.password" @keydown.enter.prevent="submitClient" />
                    <label for="inputPassword1">{{$store.state.option['senha-' + lang]}}</label>
                  </div>
                </div>
                <!--<div class="form-group">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" value="remember-me">
                      Remember Password
                    </label>
                  </div>
                </div>-->
                <a class="btn btn-primary btn-lg btn-block mao text-uppercase" @click="submitClient()" href="javascript:void(0)">{{$store.state.option['loginEntrar-' + lang]}}</a>
              </form>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-md-12 col-xs-12">
          <h2 class="text-center mt-5">{{$store.state.option['login_driver-' + lang]}}</h2>
          <div class="card card-login mx-auto">
            <div class="card-body">
              <form @submit.prevent="submitDriver()">
                <div class="form-group">
                  <div class="form-label-group">
                    <input type="email" id="inputEmail" class="form-control" :placeholder="$store.state.option['email2333-' + lang]" required="required" v-model="form.email" />
                    <label for="inputEmail">{{$store.state.option['email2333-' + lang]}}</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input type="password" id="inputPassword" class="form-control" :placeholder="$store.state.option['senha-' + lang]" required="required" v-model="form.password" @keydown.enter.prevent="submitDriver" />
                    <label for="inputPassword">{{$store.state.option['senha-' + lang]}}</label>
                  </div>
                </div>
                <a class="btn btn-primary btn-block btn-lg mao text-uppercase" @click="submitDriver()" href="javascript:void(0)">{{$store.state.option['loginEntrar-' + lang]}}</a>
              </form>
              <div class="text-center">
                <!--<router-link class="d-block small mt-3" to="/registar">{{$store.state.option['loginRegistar-' + lang]}}</router-link>-->
                <router-link class="d-block small" to="/recuperar">{{$store.state.option['loginRecuperar-' + lang]}}</router-link>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import titulo from '@/components/titulo'
import { mapMutations } from 'vuex'

export default {
  components: { titulo },
  data () {
    return {
      form: {
        email: '',
        password: ''
      },
      client: {
        username: '',
        password: '',
        clientID: ''
      },
      lang: ''
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_LOAD',
      'SET_TITULO',
      'SET_SUBTITULO',
      'SET_USER',
      'SET_AVISO',
      'SET_DRIVER'
    ]),
    init () {
      if (this.$store.state.option1) {
        this.lang = this.$store.state.lang
        this.SET_TITULO(this.$store.state.option['login_title-' + this.lang])
        this.SET_SUBTITULO(this.$store.state.option['login_subtitle-' + this.lang])
        this.SET_LOAD()
        if (this.$store.state.user.role) {
          this.$router.push('/', () => {})
        }
      } else {
        this._.delay(this.init, 100)
      }
    },
    submitClient () {
      this.SET_LOAD(true)
      // this.$localStorage.set('user', JSON.stringify(res.data))
      this.axios.post('/clients/login', this.client).then((res) => {
        res.data.role = 'client'
        this.SET_USER(res.data)
        this.axios.get('/drivers').then((res) => {
          this.SET_DRIVER(res.data)
          this._.delay(function (self) {
            self.$router.push('/admin-client', () => {})
          }, 600, this)
        }, (er) => {})
        /*
        let xxx = this.$localStorage.get('reserva')
        if (xxx) {
          xxx = JSON.parse(this.$localStorage.get('reserva'))
          this.$localStorage.remove('reserva')
          let dt = new Date(xxx.data)
          if (new Date(dt.setMinutes(dt.getMinutes() + 60)) > new Date()) {
            this.$router.push('reserved' + xxx.url, () => {})
            return
          }
        }
        */
      }, (er) => {
        this.SET_AVISO(er.response.data.error || er.response.data.message || er.response.data.status)
      })
    },
    submitDriver () {
      this.SET_LOAD(true)
      // drivers
      // this.$localStorage.set('user', JSON.stringify(res.data))
      this.axios.post('/drivers/login', this.form).then((res) => {
        res.data.date_of_Birth = res.data.Date_of_Birth
        this.SET_USER(res.data)
        if (res.data.role === 'admin') {
          this.$router.push('/admin', () => {})
          return
        }
        res.data.role = 'driver'
        this.SET_USER(res.data)
        /*
        let xxx = this.$localStorage.get('reserva')
        if (xxx) {
          xxx = JSON.parse(this.$localStorage.get('reserva'))
          this.$localStorage.remove('reserva')
          let dt = new Date(xxx.data)
          if (new Date(dt.setMinutes(dt.getMinutes() + 60)) > new Date()) {
            this.$router.push('/reserved' + xxx.url, () => {})
            return
          }
        }
        */
        this._.delay(function (self) {
          self.$router.push('/admin-driver', () => {})
        }, 600, this)
      }, (er) => {
        this.SET_AVISO(er.response.data.error || er.response.data.message || er.response.data.status)
      })
    }
  }
}
</script>
